import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { Outlet, Navigate } from "react-router-dom";
import NavBar from "../components/NavBar";

function ProtectedRoutes() {
  const { userInformation } = useContext(UserContext);
  let isLoggedIn = userInformation.isLoggedIn;

  return isLoggedIn ? (
    <>
      <NavBar />
      <Outlet />
    </>
  ) : (
    <Navigate to="/" />
  );
}

export default ProtectedRoutes;
